import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBH = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#F0F0F0",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 0a24.881 24.881 0 0 0-13.603 4.023l6.43 4.31-8.044 4.166 8.043 4.167-8.043 4.166 8.043 4.166-8.043 4.167 8.043 4.166-8.043 4.167 8.043 4.167-6.43 4.31A24.88 24.88 0 0 0 25 50c13.807 0 25-11.193 25-25S38.807 0 25 0Z"
}));
FlagBH.displayName = 'FlagBH';
export default withFlagWrapper(FlagBH);
//# sourceMappingURL=index.js.map